/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdministrationUsersInformation } from '../../models/administration-users-information';
import { KeyType } from '../../models/key-type';

export interface GetAdministrationOrganizationSiteUsersV3$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
}

export function getAdministrationOrganizationSiteUsersV3(http: HttpClient, rootUrl: string, params: GetAdministrationOrganizationSiteUsersV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrationUsersInformation>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationOrganizationSiteUsersV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdministrationUsersInformation>;
    })
  );
}

getAdministrationOrganizationSiteUsersV3.PATH = '/administration/organization-sites/{organizationSiteKey}/users';
